"use client";

import TrustBoxContainer from "@client/components/trust-pilot";

export default function TrustpilotWidget() {
  return <TrustBoxContainer height="350px" widgetType="ReviewsMiniCarousel" />;
}
